import { DateTime } from "../frontend";

export const Posts = ({ posts }: any) => (
    <ul className='posts-list'>
    {
        posts.map((post: any) => (
            <li key={post.id}>
                <a href={post.url} target='_blank' rel="noreferrer">
                    <div className='post-img-container'>
                        <img
                            src={post.featureImage}
                            alt={post.title}
                        />
                    </div>

                    <div className='pos-description-container'>
                        <p className='post-tag'>
                            {post.tag}
                        </p>

                        <p className='post-title'>
                            {post.title}
                        </p>

                        <p className='post-publishedAt'>
                            {new DateTime(post.publishedAt).getFullDate()}
                        </p>
                    </div>
                </a>
            </li>
        ))
    }
</ul>
)
